import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string[];
  image?: string;
  url?: string;
  type?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  schema?: object;
}

const defaultKeywords = [
  "Cittasya",
  "Awaken Deep rest with Yoga Nidra",
  "stress relief",
  "rejuvenation through yoga nidra",
  "Yoga Nidra for better sleep",
  "Yoga Nidra for Pain Relief",
  "Yoga Nidra for Vitality",
  "deep relaxation practice",
  "Spiritual rest and healing",
  "enhanced self-awareness",
  "Nervous system relaxation",
  "Restorative deep rest",
  "Mind-body relaxation",
  "calm tranquil mind",
  "inner peace",
  "mental clarity",
  "increase focus",
  "strengthen willpower",
  "reshape personality",
  "release tension",
  "build emotional resilience",
  "self-acceptance",
  "emotional regulation",
  "stress management",
  "Yoga Nidra",
  "improve creativity",
  "better sleep",
  "Guided Yoga Nidra",
  "Yoga Nidra benefits",
  "Yoga Nidra for healing",
  "Yoga Nidra and neuroscience",
  "physical wellness",
  "emotional wellness",
  "mental wellness",
];

export default function SEO({
  title = "Cittasya® - Awaken Deep rest with Yoga Nidra | Deep Relaxation & Stress Relief",
  description = "Transform your life with Cittasya® Yoga Nidra app. Experience guided deep relaxation practice, stress relief, better sleep, pain relief, and enhanced self-awareness through ancient Yoga Nidra techniques for mental wellness and inner peace.",
  keywords = defaultKeywords,
  image = "https://www.cittasya.com/cittasya-logo.svg",
  url = "https://cittasya.com",
  type = "website",
  author = "Cittasya®",
  publishedTime,
  modifiedTime,
  schema,
}: SEOProps) {
  const siteName = "Cittasya®";
  const twitterHandle = "@cittasya";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(", ")} />
      <meta name="author" content={author} />
      <meta
        name="robots"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:site" content={twitterHandle} />

      <meta name="format-detection" content="telephone=no" />
      <meta name="theme-color" content="#8B4513" />
      <meta name="color-scheme" content="light dark" />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
